module.exports = __webpack_public_path__ + "static/img/preview-04.083f8d31.webp";